<template>
  	<form id="mainForm" action="#" method="post">
		<Card>
	  		<template #title>
				<Toolbar>
					<template #left>
						<div class="p-card-title">Shipment Report</div>
					</template>
				</Toolbar>
	  		</template>
	  	<template #content>
			<div class="p-inputtext-sm p-fluid">
		  		<div class="grid">
					<div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
			  			<label class="col-2">{{ $t("doc_date") }}</label>
						<DatePicker	dateFormat="dd/mm/yy" v-model="header.Order_Date_From" class="col-4" />
			  			<label class="col-1">To</label>
						<DatePicker	dateFormat="dd/mm/yy" v-model="header.Order_Date_To" class="col-4" />
					</div>
					<div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
						<label class="col-2">{{ $t("created_date") }}</label>
						<DatePicker dateFormat="dd/mm/yy" v-model="header.Created_Date" class="col-4" />
						<label class="col-1">To</label>
						<DatePicker	dateFormat="dd/mm/yy" v-model="header.Created_Date_To" class="col-4" />
					</div>
					<div class="col-12">
						<FormField fieldName="Shipment_No" :labelName="$t('shipment_no')" v-model="header" FieldClass="col-6" labelClass="col-2">
							<InputText name="SAP_Order_No" type="text" class="p-inputtext-sm" v-model="header.Shipment_No" :placeholder="$t('sap_order_no')" />
						</FormField>
						<FormField fieldName="SAP_No" :labelName="$t('sap_order_no')" v-model="header" fieldClass="col-6" labelClass="col-2">
							<InputText name="SAP_Order_No" type="text" class="p-inputtext-sm" v-model="header.SAP_No" :placeholder="$t('sap_order_no')" />
						</FormField>
						<FormField fieldName="Order_No"	:labelName="$t('order_no')"	v-model="header" fieldClass="col-6" labelClass="col-2" >
							<InputText name="Order_No" v-model="header.Order_No" type="text" :placeHolder="$t('order_no')" />
						</FormField>
						<FormField fieldName="Loading_Destination_From_Id" :labelName="$t('loading')" v-model="header" fieldClass="col-6" labelClass="col-2">
							<CustomSelect v-model="header.Loading_Destination_From_Id" 	class="p-inputtext-sm" :url="this.$API_URL + 'list/location'" 	:minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Loading_Destination_To_Id" :labelName="$t('destination')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Loading_Destination_To_Id" class="p-inputtext-sm" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Transporter_Code" :labelName="$t('transporter')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Transporter_Code" class="p-inputtext-sm" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Business_Segment_Id" :labelName="$t('product_category')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Business_Segment_Id" class="p-inputtext-sm" :url="this.$API_URL + 'list/business_segment'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Warehouse_Code" :labelName="$t('warehouse')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Warehouse_Code" class="p-inputtext-sm" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
					</div>

					<div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
						<label class="col-2">{{ $t("appointment_date") }}</label>
						<DatePicker dateFormat="dd/mm/yy" v-model="header.Appointment_Date" class="col-4" />
						<label class="col-1">{{ $t('appointment_slot')}}</label>
						<CustomSelect v-model="header.Appointment_Slot" class="p-inputtext-sm col-4"  :url="this.$API_URL + 'list/appointment_slot_report'" :minLength="0" 
							:params="{ appointment_date: header.Appointment_Date, warehouse_code: header.Warehouse_Code, business_segment_id: header.Business_Segment_Id}" :filter="true" />
					</div>
					<div class="col-12">
						<FormField fieldName="Material_Code" :labelName="$t('material')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Material_Code" class="p-inputtext-sm" :url="this.$API_URL + 'list/material_all'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Distribution" :labelName="$t('distribution')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Distribution" class="p-inputtext-sm" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{group:this.$LOOKUP_GROUP.DISTRIBUTION}" :filter="true" />
						</FormField>
						<FormField fieldName="Document_Type" :labelName="$t('doc_type')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Document_Type" class="p-inputtext-sm" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.DOCUMENT_TYPE }" :filter="true" />
						</FormField>
						<FormField fieldName="Status" :labelName="$t('status')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Status" class="p-inputtext-sm" :url="this.$API_URL + 'list/shipment_status'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Progress_Status" :labelName="$t('progress_status')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Progress_Status" class="p-inputtext-sm" :url="this.$API_URL + 'list/shipment_progress_status_all'" :minLength="0" :params="{}" :filter="true" />
						</FormField>
						<FormField fieldName="Shipment_Type" :labelName="$t('shipment_type')" v-model="header" fieldClass="col-6" labelClass="col-2" >
							<CustomSelect v-model="header.Shipment_Type" class="p-inputtext-sm" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{group:this.$LOOKUP_GROUP.SHIPMENT_TYPE, allow_all: true}" :filter="true" />
						</FormField>

						<FormField fieldName="Show_Merged" labelName="Show Merged" v-model="header" fieldClass="col-6" labelClass="col-2">
							<Dropdown v-model="header.Show_Merged" class="p-inputtext-sm" :options="mergedOptions" optionLabel="label" optionValue="value" />
						</FormField>
					</div>
		  		</div>
			</div>
			<Button type="button" label="Generate" @click="getReport()" />
			&nbsp;
			<Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()" v-show="this.reportTbl"/>
	  	</template>
	</Card>
</form>
  <!-- <CustomSidebar
  >
	<template slotProps="#header"> Header </template>
	<Button
	  label="Excel"
	  icon="pi pi-file-excel pi-fw"
	  class="p-button-success"
	  @click="tableToExcel()"
	/>
	<CustomProgressSpinner
	  title="Generating Report"
	  strokeWidth="5"
	  :v-show="loadingReport"
	/>
	<div class="table-container" v-html="reportTbl"/>
  </CustomSidebar> -->

	<ShowReport
		:title="title"
		:isVisible="showReport"
		:reportTbl="this.reportTbl"
		@close="resetBtn()"
		/>

</template>

<script type="text/javascript">
import ShowReport from "../Report/ShowReport.vue";
import FormField from "../Helper/FormField.vue";
export default {
  components: {
	ShowReport,
	FormField,
  },
  data() {
	name: "ShipmentReport";
	return {
	  test: 0,
	  mode: "",
	  url: this.$API_URL + "report/",
	  reportTbl: null,
	  showReport: false,
	  loadingReport: false,
	  mergedOptions: [
		{ label: "Y", value: "Y" },
		{ label: "N", value: "N" },
	  ],
	  header: {
		Order_Date_From: null,
		Order_Date_To: null,
		Created_Date: null,
		Created_Date_To: null,
		Order_Type_Id: null,
		SAP_No: null,
		Order_No: null,
		Loading_Destination_From_Id: null,
		Loading_Destination_To_Id: null,
		Transporter_Code: null,
		Business_Segment_Id: null,
		Material_Code: null,
		Distribution: null,
		Document_Type: null,
		Shipment_Type: null,
		Warehouse_Code: null,
		Status:null,
		Customer_Code:null,
		Vendor_Code:null,
		Progress_Status:null,
		Shipment_No:null,
		Show_Merged: "N",
		Appointment_Date: null,
		Appointment_Slot: null
	  },
	};
  },
  methods: {
	reopenTab(){
	  this.showReport=true
	},
	resetBtn() {
	  this.showReport = false;
	},
	tableToExcel() {
	  this.loadingReport = !this.loadingReport;
	},
	getReport() {
	  // this.visibleBar = true;
	  // this.loadingReport = !this.loadingReport;
	  this.$emit("blockBody")
	  this.$axios
		.post(this.url + "generate_shipment", this.header)
		.then((response) => {

		  if(!response.data.success){
			this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 50000});
		  }

		  this.reportTbl = {
			header:response.data.data.header,
			content:response.data.data.content,
			title:response.data.data.title
		  }
		   this.showReport=true;
		   this.$emit("unblockBody")
		})
		.catch((exc) => {
		  // this.showError(response);
		  this.$emit("unblockBody")
		});
	},
	showError(msg) {
	  this.loadingReport = !this.loadingReport;
	},
	closeReport() {
	  this.showReport = false;
	},
  },
  mounted() {

  },
};
</script>
